export const dialogStyles = {
  '& .MuiPaper-root': {
    borderRadius: '20px',
    maxWidth: '360px',
  },
}

export const dialogContentStyles = {
  padding: '24px',
  width: 'auto',
}

export const bodyStyles = {
  marginBottom: '40px',
  marginTop: '16px',
}
